import { createSlice } from "@reduxjs/toolkit";
import {
fetchGlobalCriteria,
fetchGlobalCriteriaById,
createGlobalCriteria,
updateGlobalCriteria,
deleteGlobalCriteria
} from "@/apis/security/globalCriteriaApi";

const globalCriteriaSlice = createSlice({
  name: "globalCriteria",
  initialState: {
    list: null,
    current: null,
    
  },
  reducers: {
    setCurrentCriteria:(state,action)=>{
      state.current=action.payload
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchGlobalCriteria.fulfilled, (state, { payload }) => {
        state.list = payload; 
      })
      .addCase(fetchGlobalCriteriaById.fulfilled, (state, { payload }) => {
        state.current = payload;
      })
      .addCase(createGlobalCriteria.fulfilled, (state, { payload }) => {
        state.list = [payload,...(state.list || [])];
      })
      .addCase(updateGlobalCriteria.fulfilled, (state, { payload }) => {
        state.list = (state.list || []).map((g) =>
          g.globalCriteriaID === payload.globalCriteriaID ? payload : g
        );
      })
      .addCase(deleteGlobalCriteria.fulfilled, (state, { payload }) => {
        state.list = (state.list || []).filter(
          (g) => g.globalCriteriaID !== payload
        );
        if (state.current?.globalCriteriaID === payload) {
          state.current = null;
        }
      });
  },
});

export const { setCurrentCriteria } = globalCriteriaSlice.actions;
export default globalCriteriaSlice.reducer;
